module.exports = __webpack_public_path__ + "img/c3.d049d94a.png";